import React from 'react';
import PropTypes from 'prop-types';
import { getStaticImageUrl } from 'client/utils/image-helpers';

import './price-drop-graph-tooltip.scss';

const DEAL_TYPE_ICONS = {
  Great: 'price-rating-graphic/price-rating-pin-great.svg',
  Good: 'price-rating-graphic/price-rating-pin-good.svg',
  Fair: 'price-rating-graphic/price-rating-pin-fair.svg',
  High: 'price-rating-graphic/price-rating-pin-high.svg',
};

const PIN_WIDTH = 40;
const PIN_HEIGHT = 47;
const OFFSET = 9;

export function PriceDropGraphTooltip({ tooltipData = null, dealType = '' }) {
  if (!(tooltipData && DEAL_TYPE_ICONS[dealType])) return null;

  const { cx, cy, dotRef } = tooltipData;

  // eslint-disable-next-line react-hooks/refs -- dotRef is passed as prop data from parent; reading .current here is the intended API
  if (!dotRef?.current) return null;

  return (
    <div
      className="price-drop-graph-tooltip pos-a top-0 left-0"
      style={{ transform: `translate(${cx - PIN_WIDTH / 2}px, ${cy - PIN_HEIGHT - OFFSET}px)` }}
    >
      <img
        className="deal-type-pin"
        src={getStaticImageUrl(DEAL_TYPE_ICONS[dealType])}
        alt="deal type pin"
        width={PIN_WIDTH}
      />
    </div>
  );
}

PriceDropGraphTooltip.propTypes = {
  tooltipData: PropTypes.shape({
    cx: PropTypes.number,
    cy: PropTypes.number,
    dotRef: PropTypes.shape({ current: PropTypes.object }),
  }),
  dealType: PropTypes.string,
};
